import {
  WhatsappTemplateButtonTypeEnum,
  WhatsappTemplateCategoryEnum,
} from "../enums";
import { handleMessageChange } from "./handleMessageChange";

export async function handleTemplateSelectionChange({
  value,
  nodes,
  setNodes,
  templates,
  templatesByName,
  api,
  urlButton,
  urlButton2,
}) {
  const defaultBody = "";
  const defaultHeaderParameters = {};
  const defaultButtons = [];
  const defaultUrlButton = null;
  const defaultUrlButton2 = null;
  const selectedNode = nodes.find((n) => n.selected);

  handleMessageChange(
    "buttons",
    defaultButtons,
    nodes,
    setNodes,
    selectedNode,
  );
  handleMessageChange("flowButton", null, nodes, setNodes, selectedNode);
  handleMessageChange(
    "urlButton",
    defaultUrlButton,
    nodes,
    setNodes,
    selectedNode,
  );
  handleMessageChange(
    "urlButton2",
    defaultUrlButton2,
    nodes,
    setNodes,
    selectedNode,
  );
  handleMessageChange("copyCodeButton", null, nodes, setNodes, selectedNode);
  handleMessageChange(
    "limitedTimeOffer",
    undefined,
    nodes,
    setNodes,
    selectedNode,
  );

  // Mettre à jour le message avec les valeurs réinitialisées
  handleMessageChange("body", defaultBody, nodes, setNodes, selectedNode);
  handleMessageChange(
    "whatsappTemplateName",
    value,
    nodes,
    setNodes,
    selectedNode,
  );
  handleMessageChange("headerParameters", {}, nodes, setNodes, selectedNode);
  handleMessageChange("bodyParameters", null, nodes, setNodes, selectedNode);
  handleMessageChange("urlClicks", null, nodes, setNodes, selectedNode);
  handleMessageChange("urlClicks2", null, nodes, setNodes, selectedNode);
  handleMessageChange("urlClickRate", 0, nodes, setNodes, selectedNode);
  handleMessageChange("urlClickRate2", 0, nodes, setNodes, selectedNode);

    handleMessageChange(
      "headerParameters",
      defaultHeaderParameters,
      nodes,
      setNodes,
    );

  let selectedTemplate;
  if (templates) {
    selectedTemplate = templates.find((t) => t.name === value);
  } 

  const _limitedTimeOffer = selectedTemplate?.components?.find(
    (c) => c.type === "LIMITED_TIME_OFFER",
  )?.limited_time_offer
    ? {
        expirationDate: undefined,
        expirationDelayInMinutes: undefined,
        expirationType: "delay",
        text: selectedTemplate?.components?.find(
          (c) => c.type === "LIMITED_TIME_OFFER",
        )?.limited_time_offer.text,
      }
    : null;
  const body =
    selectedTemplate?.components?.find((c) => c.type === "BODY")?.text ?? "";
  const footer =
    selectedTemplate?.components?.find((c) => c.type === "FOOTER")?.text ?? "";
  const carousel =
    selectedTemplate?.components?.find((c) => c.type === "CAROUSEL") ?? null;
  const cards = carousel?.cards || null;

  if (cards) {
    let officialWhatsappTemplate =
      await api.officialWhatsappTemplate.maybeFindFirst({
        filter: {
          name: { equals: value },
        },
        select: {
          id: true,
          urlButtonsInCards: true,
        },
      });
    let officialButtons;
    if (
      officialWhatsappTemplate &&
      officialWhatsappTemplate.urlButtonsInCards
    ) {
      officialButtons = officialWhatsappTemplate.urlButtonsInCards;
    }

    const updatedCards = cards.map((card, index) => {
      const headerComponent = card.components.find((c) => c.type === "HEADER");
      const bodyComponent = card.components.find((c) => c.type === "BODY");
      const buttonsComponent = card.components.find(
        (c) => c.type === "BUTTONS",
      );

      const matchingUrlButtons = officialButtons?.find(
        (item) => item.cardIndex === index,
      );
      let btnIndex = 0;
      const updatedButtons =
        buttonsComponent?.buttons.map((button) => {
          if (
            (button.type === "URL" || button.type === "url") &&
            button.url.includes("redirect")
          ) {
            const newUrl =
              matchingUrlButtons?.buttons?.[btnIndex]?.url || button.url;
            btnIndex++; // On incrémente seulement après avoir récupéré l’URL

            return {
              ...button,
              url: newUrl,
            };
          }
          return button;
        }) || [];
      const bodyText = bodyComponent?.text || "";
      const paramMatches = bodyText.match(/{{\d+}}/g);
      const bodyParameters = paramMatches
        ? paramMatches.map(() => ({
            type: "text",
            selected: `contact.whatsappName`,
          }))
        : [];

      return {
        components: [
          {
            type: "HEADER",
            format: headerComponent?.format === "IMAGE" ? "IMAGE" : "VIDEO",
            link:
              headerComponent?.parameters?.[0]?.image?.link ||
              headerComponent?.parameters?.[0]?.video?.link ||
              "",
          },
          {
            type: "BODY",
            text: bodyComponent?.text || "",
            bodyParameters: bodyParameters.length > 0 ? bodyParameters : null,
          },
          {
            type: "BUTTONS",
            buttons: updatedButtons || [],
          },
        ],
      };
    });

    handleMessageChange(
      "cards",
      updatedCards,
      nodes,
      setNodes,
      selectedNode,
    );
  } else {
    handleMessageChange("cards", cards, nodes, setNodes, selectedNode);
  }
  let category;
  if (_limitedTimeOffer) {
    category = WhatsappTemplateCategoryEnum.LIMITED_TIME_OFFER;
  } else if (cards) {
    category = WhatsappTemplateCategoryEnum.CAROUSEL;
  } else {
    category = selectedTemplate?.category;
  }

  handleMessageChange("category", category, nodes, setNodes, selectedNode);
  handleMessageChange(
    "limitedTimeOffer",
    _limitedTimeOffer,
    nodes,
    setNodes,
    selectedNode,
  );
  handleMessageChange("body", body, nodes, setNodes, selectedNode);
  handleMessageChange("footer", footer, nodes, setNodes, selectedNode);

  // Mettre à jour les paramètres de l'en-tête
  const headerImage = selectedTemplate?.components?.find(
    (c) => c.format === "IMAGE" && c.type === "HEADER",
  );
  const headerVideo = selectedTemplate?.components?.find(
    (c) => c.format === "VIDEO" && c.type === "HEADER",
  );
  const bodyComponent = selectedTemplate?.components?.find(
    (c) => c.type === "BODY",
  );

  if (headerImage ) {
    let link = selectedTemplate?.components[0]?.example?.header_handle[0] ?? "";
    if (
      link ===
      "https://scontent.whatsapp.net/v/t61.29466-34/374730438_619291030350833_3365796789354478627_n.jpg?ccb=1-7&_nc_sid=8b1bef&_nc_ohc=Mm-lFP-n6HQQ7kNvgHcop0-&_nc_ht=scontent.whatsapp.net&edm=AH51TzQEAAAA&_nc_gid=Ai9pJ5h-3MJtuQM9kod7mBf&oh=01_Q5AaIK5wjbv23H36O10tfiAU7rYboYXGSVs3XE3pcUFtrAq0&oe=670AD7D6"
    ) {
      link = "";
    }

    handleMessageChange(
      "headerParameters",
      { type: "image", image: { link: link } },
      nodes,
      setNodes,
      selectedNode,
    );
  } else if (headerVideo ) {
    let link = selectedTemplate?.components[0]?.example?.header_handle[0] ?? "";
    if (
      link ===
      "https://storage.gadget.dev/files/22129/42940/media/file/xDycluQ_j76bA150Asp7G/2bc118d2-9e93-405c-9b5e-dced1b1051c0"
    ) {
      link = "";
    }
    handleMessageChange(
      "headerParameters",
      { type: "video", video: { link: link } },
      nodes,
      setNodes,
      selectedNode,
    );
  }
  if (bodyComponent?.example) {
    var bodyParams = [];
    bodyComponent.example?.body_text[0].map(() => {
      bodyParams.push({
        type: "text",
        selected: "contact.whatsappName",
      });
    });
    handleMessageChange(
      "bodyParameters",
      bodyParams,
      nodes,
      setNodes,
      selectedNode,
    );
  }

  const buttons = selectedTemplate?.components?.find(
    (c) => c.type === "BUTTONS",
  )?.buttons;

  let replyButtons = [];
  let hasUrlButton = false;

  const isUrlButtonAtBottom = buttons?.length > 0 && buttons[0]?.type !== "URL";

  handleMessageChange(
    "isUrlButtonAtBottom",
    isUrlButtonAtBottom,
    nodes,
    setNodes,
    selectedNode,
  );

  console.log(
    `Boutons dans le template ${value} buttons=${JSON.stringify(buttons)}`,
  );

  buttons?.map(async (button) => {
    const { type, text, example } = button;
    console.log(`Bouton type=${type} text=${text}, example=${example}`);

    switch (type) {
      case WhatsappTemplateButtonTypeEnum.URL:
        {
          let officialWhatsappTemplate =
            await api.officialWhatsappTemplate.maybeFindFirst({
              filter: {
                name: { equals: value },
              },
              select: {
                id: true,
                buttonUrlLink: true,
                buttonUrlLink2: true,
              },
            });

          if (officialWhatsappTemplate) {
            const buttonConfig = {
              first: {
                key: "urlButton",
                url: officialWhatsappTemplate.buttonUrlLink || button.url,
                button: urlButton,
              },
              second: {
                key: "urlButton2",
                url: officialWhatsappTemplate.buttonUrlLink2 || button.url,
                button: urlButton2,
              },
            };

            const currentConfig = hasUrlButton
              ? buttonConfig.second
              : buttonConfig.first;

            handleMessageChange(
              currentConfig.key,
              {
                text: text,
                url: currentConfig.url,
                trackingEnabled: true, // Default to enabled for official templates
                ...(currentConfig.button && {
                  gadgetId: currentConfig.button.gadgetId,
                  redirectionUrlId: currentConfig.button.redirectionUrlId,
                }),
              },
              nodes,
              setNodes,
              selectedNode,
            );

            if (!hasUrlButton) {
              hasUrlButton = true;
            }
          }
        }
        break;

      case WhatsappTemplateButtonTypeEnum.COPY_CODE:
        handleMessageChange(
          "copyCodeButton",
          { text: example[0] },
          nodes,
          setNodes,
          selectedNode,
        );
        break;

      case WhatsappTemplateButtonTypeEnum.FLOW:
        {
          const officialWhatsappTemplate = templatesByName[value];
          if (!officialWhatsappTemplate) {
            console.error("No official whatsapp template found");
            return;
          }
          console.log(
            `Official whatsapp template found with name ${value}: ${JSON.stringify(officialWhatsappTemplate)}`,
          );
          const flowButton = (officialWhatsappTemplate.components || [])
            .find(({ type }) => type === "BUTTONS")
            ?.buttons?.find(({ type }) => type === "FLOW");
          
          if (flowButton) {
            const { text, flow_id, flow_action, navigate_screen } = flowButton;
            console.log(
              `Flow button found text=${text} flow_id=${flow_id} flow_action=${flow_action} navigate_screen=${navigate_screen}`,
            );

            handleMessageChange(
              "flowButton",
              {
                flowId: flow_id,
                flowAction: flow_action,
                navigateScreen: navigate_screen,
                text,
              },
              nodes,
              setNodes,
              selectedNode,
            );
          }
        }
        break;

      default:
        replyButtons.push({
          title: text,
        });
        break;
    }
  });

  handleMessageChange(
    "buttons",
    replyButtons,
    nodes,
    setNodes,
    selectedNode,
  );

  handleMessageChange(
    "status",
    selectedTemplate?.status?.toLowerCase(),
    nodes,
    setNodes,
    selectedNode,
  );
  handleMessageChange("hasFailed", false, nodes, setNodes, selectedNode);
}
